import React, { Dispatch, Fragment, SetStateAction } from 'react';
import moment from 'moment';

import { User, X } from 'lucide-react';

import { useGetConversationForCompleteData } from '../../../hooks/conversations';

interface ConversationsViewProps {
    open: boolean;
    conversationId: string | null;
    setConversationsViewData: Dispatch<SetStateAction<{ conversationId: string } | null>>;
};
export const ConversationsView = (props: ConversationsViewProps) => {
    const { open, conversationId, setConversationsViewData } = props;

    const { data: conversation, isLoading: isConversationLoading } = useGetConversationForCompleteData(conversationId);

    return (
        <div className={`complete_data__conversation ${open ? 'complete_data__conversation--open' : ''}`}>
            <div className='card card--md complete_data__conversation__content'>
                <div className='complete_data__conversation__header'>
                    <div>
                        <p className='text-lg text-bold mb-sm'>Conversation for:</p>
                        {conversation && (
                            <Fragment>
                                <p className='text-sm text-medium color--gray-600'>Scenario: <span className='color--gray-800'>{conversation.simulation_name}</span></p>
                                <p className='text-sm text-medium color--gray-600'>Persona: <span className='color--gray-800'>{conversation.stage_person} ({conversation.stage_title})</span></p>
                                <p className='text-sm text-medium color--gray-600'>Attempt: <span className='color--gray-800'>{conversation.version}</span></p>
                                <p className='text-sm text-medium color--gray-600'>Created on: <span className='color--gray-800'>{moment(conversation.created_at).format('MMM DD, YYYY')}</span></p>
                            </Fragment>
                        )}
                    </div>
                    <button
                        className='complete_data__conversation__header__close_btn'
                        onClick={() => setConversationsViewData(null)}
                    >
                        <X />
                    </button>
                </div>
                {isConversationLoading && (
                    <div className='d-flex flex-column gap-sm justify-content-center align-items-center'>
                        <div className='list-loader' />
                        <p className='text-semibold'>Loading Conversation</p>
                    </div>
                )}
                {!isConversationLoading && !conversation?.chats.length && (
                    <div className='d-flex flex-column gap-sm justify-content-center align-items-center'>
                        <p className='text-semibold'>No messages yet!</p>
                    </div>
                )}
                {!isConversationLoading && conversation?.chats.length && (
                    <div className='complete_data__conversation__chats'>
                        {conversation.chats.map((chat) => (
                            <div
                                key={chat.id}
                                className={`complete_data__conversation__chats__message complete_data__conversation__chats__message--${chat.source}`}
                            >
                                <div className='complete_data__conversation__chats__message__left'>
                                    {/* {chat.source === 'bot' ? <Bot /> : <User />} */}
                                    <User />
                                    {chat.created_at && <p>{moment(chat.created_at).format('HH:mm')}</p>}
                                </div>
                                <div className='complete_data__conversation__chats__message__text'>
                                    {chat.message}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};